import { render } from "./Google.vue?vue&type=template&id=bb68df72"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Google.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb68df72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb68df72', __exports__)) {
    api.reload('bb68df72', __exports__)
  }
  
  module.hot.accept("./Google.vue?vue&type=template&id=bb68df72", () => {
    api.rerender('bb68df72', render)
  })

}


export default __exports__